import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assets',
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.scss']
})
export class AssetsComponent implements OnInit {

  selectedOption: string;
  selectMenu=1;
  
  constructor() { }

  ngOnInit() {
  }

}
